import React, { useState } from "react";
import { Menu, Dropdown, Avatar, Modal, Card, Input, Form, Button, message } from "antd";
import { connect } from 'react-redux'
import {
  EditOutlined,
  SettingOutlined,
  ShopOutlined,
  QuestionCircleOutlined,
  LogoutOutlined,
  LockOutlined
} from '@ant-design/icons';
import Icon from 'components/util-components/Icon';
import { logoutUser } from "utils/redux/actions/loginAction";
import { bindActionCreators } from "redux";
import { FIRM_NAME, NAME_SURNAME, USER_IMAGE, USERNAME } from "constants/StorageConstant";
import globalConstant from "constants/globalConstant";
import { useTranslation } from "react-i18next";
import network from "network/network";

const menuItem = [
  {
    title: "Edit Profile",
    icon: EditOutlined,
    path: "/"
  },

  {
    title: "Account Setting",
    icon: SettingOutlined,
    path: "/"
  },
  {
    title: "Billing",
    icon: ShopOutlined,
    path: "/"
  },
  {
    title: "Help Center",
    icon: QuestionCircleOutlined,
    path: "/"
  }
]

export const NavProfile = ({ logoutUserAction }) => {

  const { t, i18n } = useTranslation();
  const [isChangeOpen, setIsChangeOpen] = useState(false);
  const firmName = localStorage.getItem(FIRM_NAME);
  const nameSurname = localStorage.getItem(NAME_SURNAME) || "";
  const userImage = localStorage.getItem(USER_IMAGE) || "";
  const [form] = Form.useForm();

  const logoutClick = () => {
    logoutUserAction();
    setTimeout(() => {
      window.location.reload();
    }, 100);

  }


  const handlesubmitForm = async (values) => {
    var userName = localStorage.getItem(USERNAME);
    var oldPassword = values.oldPassword
    var newPassword = values.newPassword

    var result = await network.get("/admin/Account/updatePassword", { userName, oldPassword, newPassword });

    if (result.data.isSuccess) {
      message.success("Şifre Başarıyla Değiştirildi")
      setIsChangeOpen(false);
      form.resetFields();
    } else {
      message.error("Eski Şifrenizi Doğru Girnemiz Gerekmektedir")

    }
  }

  const handleCloseModal = () => {

  }

  const profilePath = globalConstant.imageTypes.getImageUrl(globalConstant.imageTypes.userImage.type, userImage);

  const profileMenuItems = [
    {
      key: `${menuItem.length + 2}`,
      label: (
        <span>
          <LockOutlined className="mr-3" />
          <span className="font-weight-normal">{t('updatePassword')}</span>
        </span>
      ),
      onClick: () => setIsChangeOpen(true),
    },
    {
      key: `${menuItem.length + 1}`,
      label: (
        <span>
          <LogoutOutlined className="mr-3" />
          <span className="font-weight-normal">{t('Logout')}</span>
        </span>
      ),
      onClick: () => logoutClick(),
    }
  ];

  const profileDropdown = (
    <div className="nav-profile nav-dropdown">
      <div className="nav-profile-header">
        <div className="d-flex">
          <Avatar size={45} src={profilePath} />
          <div className="pl-3">
            <h4 className="mb-0">{firmName}</h4>
            <h6 className="mb-0">{nameSurname}</h6>
            {/* <span className="text-muted">Frontend Developer</span> */}
          </div>
        </div>
      </div>
      <div className="nav-profile-body">
        <Menu items={profileMenuItems} />
      </div>
    </div>
  );
  return (
    <div>

      <Dropdown placement="bottomRight" trigger={["click"]} dropdownRender={() => profileDropdown}>
        <div
          className="d-flex align-item-center"
          role="button"
          tabIndex={0}
          style={{ width: '36px', height: '36px', alignItems: 'center', justifyContent: 'center' }}
        >
          <Avatar size={36} src={profilePath} />
        </div>
      </Dropdown>



      <Modal title={t('updatePassword')} onCancel={() => {
        setIsChangeOpen(false);
        form.resetFields();

      }} open={isChangeOpen} width={"400px"} footer={null}>
        <Form form={form} layout="vertical" onFinish={handlesubmitForm}>
          <Form.Item
            label={t("oldPassword")}
            name="oldPassword"
            rules={[{ required: true, message: t("oldPasswordRequired") }]}
          >
            <Input.Password
              style={{ width: "100%" }}
              placeholder={t("enterOldPassword")}
            />
          </Form.Item>

          <Form.Item
            label={t("newPassword")}
            name="newPassword"
            rules={[
              { required: true, message: t("newPasswordRequired") },
              { min: 6, message: t("passwordMinLength") },
            ]}
          >
            <Input.Password
              style={{ width: "100%" }}
              placeholder={t("enterNewPassword")}
            />
          </Form.Item>

          <Form.Item
            label={t("confirmPassword")}
            name="confirmPassword"
            dependencies={["newPassword"]}
            rules={[
              { required: true, message: t("confirmPasswordRequired") },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(t("passwordMismatch")));
                },
              }),
            ]}
          >
            <Input.Password
              style={{ width: "100%" }}
              placeholder={t("enterConfirmPassword")}
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: "100%" }}>
              {t("updatePassword")}
            </Button>
          </Form.Item>
        </Form>

      </Modal>

    </div>
  );
}

// export default connect(null, {signOut})(NavProfile)


function mapStateToProps(state) {

  return {


  }
}

function mapDispatchToProps(dispatch) {
  return {
    logoutUserAction: bindActionCreators(logoutUser, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NavProfile);
